// Puente de SOLO LECTURA (+ 1 escritura) hacia `admin`/settings (plan.md §3.4, decisión M de
// tasks.md). Retiro: cuando migre `admin`/settings y exponga lectura/escritura de settings.
//
// v1 sustituyó `/app-settings` (bolsa de claves sueltas) por `/app-settings/theme`, un recurso
// con control de concurrencia: la escritura exige la `version` leída (`UpdateApplicationThemeRequest`).

import { z } from 'zod';
import apiClient from '@shared/api/http';

const ThemeDtoSchema = z.object({
  primaryBrandColor: z.string().nullish(),
  version: z.number(),
});

export const appSettingsRepository = {
  // El default '#FF4630' lo pone el hook de application/, no este repositorio (UC-7).
  async getThemeColor(): Promise<string | undefined> {
    const { data } = await apiClient.get('/app-settings/theme');
    return ThemeDtoSchema.parse(data).primaryBrandColor ?? undefined;
  },

  // Relee la versión vigente antes de escribir: v1 rechaza la actualización si no coincide.
  async updateThemeColor(value: string): Promise<void> {
    const { data } = await apiClient.get('/app-settings/theme');
    const { version } = ThemeDtoSchema.parse(data);
    await apiClient.put('/app-settings/theme', { primaryBrandColor: value, version });
  },
};
